export const enum SubscriptionStatus {
  init,
  connected,
  closed,
  connecting,
  reconnecting,
}
